(function () {
  'use strict';
  document.addEventListener('click', function (event) {
    var trigger = event.target.closest('[data-mackai-open]');
    if (!trigger) return;
    if (window.VelodromChat) {
      event.preventDefault();
      window.VelodromChat.open();
      if (!document.querySelector('.vchat-panel:not([hidden])')) {
        var context = trigger.closest('.vrh-hero-actions, .vrh-inline, .vrh-help');
        var status = context && context.querySelector('[data-mackai-status]');
        if (status) status.textContent = document.documentElement.lang.indexOf('es') === 0 ? 'El chat no está disponible ahora. Escríbenos a info@velodrom.cc.' : 'Chat is unavailable right now. Please email info@velodrom.cc.';
      }
    }
    // If the widget failed to load, the ordinary email link still works.
  });
})();
